import {
  AssumptionApi as AssumptionApiGen,
  ConditionalAssumptionApi as ConditionalAssumptionApiGen,
  EntityApi as EntityApiGen,
  EntityTypeApi as EntityTypeApiGen,
  NavigatorApi as NavigatorApiGen,
  RelationshipApi as RelationshipApiGen,
  RelationshipEventApi as RelationshipEventApiGen,
  SharedApi as SharedApiGen,
  ChangelogApi as ChangelogApiGen,
  UserStorageApi as UserStorageApiGen,
} from './gen/navigator'
import { RestApiConfiguration, LegacyApiConfiguration } from './config'
import { EntityApi as EntityLegacyApiGen, ModelApi as ModelLegacyApiGen } from './gen/legacy'
import { CalculationLogApi as CalculationLogLegacyApiGen } from './gen/legacy'

export const AssumptionApi = new AssumptionApiGen(RestApiConfiguration)
export const ConditionalAssumptionApi = new ConditionalAssumptionApiGen(RestApiConfiguration)
export const EntityApi = new EntityApiGen(RestApiConfiguration)
export const EntityTypeApi = new EntityTypeApiGen(RestApiConfiguration)
export const NavigatorApi = new NavigatorApiGen(RestApiConfiguration)
export const RelationshipApi = new RelationshipApiGen(RestApiConfiguration)
export const RelationshipEventApi = new RelationshipEventApiGen(RestApiConfiguration)
export const SharedApi = new SharedApiGen(RestApiConfiguration)

export const ChangelogApi = new ChangelogApiGen(RestApiConfiguration)
export const UserStorageApi = new UserStorageApiGen(RestApiConfiguration)

// LEGACY ILM CALLS
export const EntityLegacyApi = new EntityLegacyApiGen(LegacyApiConfiguration)
export const ModelApi = new ModelLegacyApiGen(LegacyApiConfiguration)
export const CalculationLogApi = new CalculationLogLegacyApiGen(LegacyApiConfiguration)
